import { Injectable } from '@angular/core';
import { Feature } from 'ol';
import { LineString } from 'ol/geom';
import { BehaviorSubject, Subject } from 'rxjs';
import { AttrIndexService } from './attr-index.service';
import { MainDataService } from './main-data.service';
import { MapSharedService } from './map-shared.service';

export interface SplitLine {
	id;
	splitPoint?: number[];
	splitPartsId?: any[];
	isCancel?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class EditSplitMergeService {

	splitLineBS: BehaviorSubject<SplitLine> = new BehaviorSubject(null);
	splitToolBS: BehaviorSubject<{
		action: 'start' | 'stop'
	}> = new BehaviorSubject(null);
	mergeLineBS: BehaviorSubject<{
		ids: any[];
		mergedRec?;
		isApply?: boolean
	}> = new BehaviorSubject(null);
	mergeToolBS: BehaviorSubject<{
		action: 'start' | 'stop'
	}> = new BehaviorSubject(null);

	constructor(
		private attrIndexService: AttrIndexService,
		private mainDataService: MainDataService,
		private mapSharedService: MapSharedService
	) { }

	splitLineFeat(fallOnFeat: Feature<LineString>, fallOnPoint: number[]) {
		const idCol = this.attrIndexService.rcUuidCol;
		const lineCoords: number[][] = fallOnFeat.getGeometry().getCoordinates();
		const fallOnFeatAttrs = this.mainDataService.getDataAttrs(fallOnFeat.getId());

		const pos = this.mapSharedService.findCoordPositionOnLine(fallOnPoint, lineCoords);
		const partA = lineCoords.slice(0, pos[0] + 1);
		partA.push(fallOnPoint);
		const partB = lineCoords.slice(pos[1]);
		partB.unshift(fallOnPoint);
		// Create and add a new feat using partA
		let recPartA = this.mainDataService.addNewCard(idCol);
		const partAId = recPartA[idCol];
		Object.keys(fallOnFeatAttrs).forEach(key => {
			if (!recPartA.hasOwnProperty(key)) {
				// recPartA[key] = fallOnFeatAttrs[key];
				this.mainDataService.setDataAttrs(partAId, key, fallOnFeatAttrs[key]);
			}
		})
		const featA = fallOnFeat.clone();
		featA.setId(partAId);
		featA.setGeometry(new LineString(partA));
		// Create and add a new feat using partB
		let recPartB = this.mainDataService.addNewCard(idCol);
		const partBId = recPartB[idCol];
		Object.keys(fallOnFeatAttrs).forEach(key => {
			if (!recPartB.hasOwnProperty(key)) {
				// recPartB[key] = fallOnFeatAttrs[key];
				this.mainDataService.setDataAttrs(partBId, key, fallOnFeatAttrs[key]);
			}
		});
		// Add the original id before split
		this.mainDataService.setDataAttrs(partAId, this.attrIndexService.idBeforeSplitKey, fallOnFeat.getId());
		this.mainDataService.setDataAttrs(partBId, this.attrIndexService.idBeforeSplitKey, fallOnFeat.getId());
		
		const featB = fallOnFeat.clone();
		featB.setId(partBId);
		featB.setGeometry(new LineString(partB));

		return {
			featA: featA,
			featB: featB
		}
	}

}
